// redux/selectors/presence/presenceSelectors.ts

import { RootState } from "../../storeTypes";

export const selectPresenceState = (state: RootState) => state.presence;

export const selectPresenceOnlineUsersMap = (state: RootState) =>
  state.presence.onlineUsers;

export const selectPresenceLastSeenMap = (state: RootState) =>
  state.presence.lastSeenByUser;

export const makeSelectIsUserOnline =
  (userId: number) => (state: RootState) =>
    Boolean(state.presence.onlineUsers[userId]);

export const makeSelectUserLastSeen =
  (userId: number) => (state: RootState) =>
    state.presence.lastSeenByUser[userId] ?? null;

export const selectPresenceOnlineUserIds = (state: RootState) =>
  Object.keys(state.presence.onlineUsers)
    .map((id) => Number(id))
    .filter((id) => Number.isFinite(id) && id > 0);